import * as React from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker, DatePickerProps, LocalizationProvider } from '@mui/x-date-pickers';
import { de } from 'date-fns/locale';
import { Typography } from '@mui/material';

interface DHbDatePickerProps extends DatePickerProps {
    disablePast?: boolean;
    errorText?: string;
}

export const DHDatePicker = (props: DHbDatePickerProps) => {
    return (
        // For now, we only support the de format for date values (01.02.2023)
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={de}>
            <DatePicker
                sx={{ flex: 1, '.MuiInputBase-root': { height: 56 } }}
                disablePast={props.disablePast ?? true}
                {...props}
            />
            {props.errorText && (
                <Typography variant='body2' color='error'>
                    {props.errorText}
                </Typography>
            )}
        </LocalizationProvider>
    );
};
